:host{z-index:1080;width:min(360px,100vw - 2rem);max-width:calc(100vw - 2rem);max-height:none;overflow:visible;border-color:#0c234257;box-shadow:0 .75rem 2rem #0c23422e}
/*# sourceMappingURL=widget-options-menu.component-R3SCNWJS.css.map */
